// extracted by mini-css-extract-plugin
export var arrows = "_2a-5";
export var decrementer = "_2a-9";
export var disabled = "_2a-3";
export var error = "_2a-1";
export var hiddenText = "_2a-a";
export var incrementer = "_2a-8";
export var input = "_2a-7";
export var inputWrapper = "_2a-0";
export var leadingIcon = "_2a-b";
export var readonly = "_2a-2";
export var regular = "_2a-6";
export var small = "_2a-4";